import { render } from "./AMLReport.vue?vue&type=template&id=b3e636e0&scoped=true"
import script from "./AMLReport.vue?vue&type=script&lang=js"
export * from "./AMLReport.vue?vue&type=script&lang=js"

import "./AMLReport.vue?vue&type=style&index=0&id=b3e636e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e636e0"]])

export default __exports__